import { Base } from '../base-component';
import './video-related-video-stack.component.scss';

import * as $ from 'jquery';

export class VideoRelatedVideoStack extends Base {

	constructor(element: Element){

		super(element);

	}

	containers: any;
	containersJs: any;
	buttons: any;
	scrollTO: any;
	clickedTarget: any;

	init(){

		this.containers = Array.from(this.element.querySelectorAll('.video-related-video-stack-item__type-feature'));
		this.buttons = Array.from(this.element.querySelectorAll('.video-related-video-stack-item'));
		window.addEventListener('resize', ()=>{
			this.videoSameHeight();
		});

	}

	bindEvents() {

		this.buttons.map((item) => item.addEventListener('click', (event) => {

			let element;
			let clickedExternal;
			let clickedTarget = event.target;
			element = clickedTarget.closest('.video-related-video-stack-item');
			let clickedIndex = element.getAttribute('data-index'); 
			if(element.getAttribute('data-youtube-id')){
				clickedExternal = element.getAttribute('data-youtube-id');
			}

			this.hideActiveButtons();
			element.classList.add('active');

			this.hideContainers();
			this.containers.map((item) => {
				if(item.getAttribute('data-index') === clickedIndex) {
					item.classList.remove('d-none');
					if(document.querySelector('.header')) {
						if(document.querySelector('.header').classList.contains('header--sticky')) {
							$('html,body').animate({ 
								scrollTop: $(this.element).offset().top - 65
							}, 'slow');
						}else{
							$('html,body').animate({ 
								scrollTop: $(this.element).offset().top - 195
							}, 'slow');
						}
					}
					if(clickedExternal) {
						this.generateExternalVideo(item);
					}
					this.pauseOtherVideos(item);
				}
				
			});
			
		}));
	
	}

	hideActiveButtons() {
		this.buttons.map((item) => {
			item.classList.remove('active');
		});
	}

	hideContainers() {
		this.containers.map((item) => {
			item.classList.add('d-none');
		});
	}

	hideActiveVideo(element){
		
		let videoContainer = element.querySelector('.video');
		
		if(!videoContainer.classList.contains('video--playing')){

			let videoContainers: any = Array.from(document.querySelectorAll('.video--playing'));

			videoContainers.map((itemContainer) => {
				itemContainer.classList.remove('video--playing');
				let iframeExistence: any = itemContainer.querySelector('iframe');
				if(iframeExistence){
					let iframeChildren = $(itemContainer).find('iframe');
					iframeChildren.remove();
				}else{
					let videoChildren: any = itemContainer.querySelector('video');
					let playerChildren: any = itemContainer.querySelector('.ot-video-containingBlock');
					videoChildren.pause();
				}
			});
						
		}

	}

	pauseOtherVideos(container: any) {
        if(container) {
			let dataIndex = container.getAttribute('data-index');
			this.containers.map(((containerChild)=>{
				let vidavee = Array.from(containerChild.querySelectorAll('video'));
				let youtube = Array.from(containerChild.querySelectorAll('iframe'));
				vidavee.map((video)=>{
                    video.pause();
				});
				youtube.map((video)=>{
                    video.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
				});
			}));
		}
	}

	videoSameHeight() {
		if(this.element.querySelector('.mejs__video')){
			let height = this.element.querySelector('.mejs__video').style.height;
			let iframes = Array.from(this.element.querySelectorAll('.youtube-video'));
			iframes.map((frame)=>{
				frame.setAttribute('height', height)
			})
		}
	}

	generateExternalVideo(container: any) {
		this.videoSameHeight();
	}

}


// WEBPACK FOOTER //
// ./components/video-related-video-stack/video-related-video-stack.component.ts